import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { ListAzureUnassignedNetworkInterfaces200Response } from '../models/ListAzureUnassignedNetworkInterfaces200Response';
import { ListAzureUnassignedNetworkInterfacesRequest } from '../models/ListAzureUnassignedNetworkInterfacesRequest';

/**
 * no description
 */
export class ListAzureUnassignedNetworkInterfacesApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Get all Unassigned network interfaces in subscription
   * @param accountId ID of the restore account
   * @param projectId The project ID
   * @param listAzureUnassignedNetworkInterfacesRequest The request body for listing unassigned network interfaces
   */
  public async listAzureUnassignedNetworkInterfaces(accountId: string, projectId: string, listAzureUnassignedNetworkInterfacesRequest: ListAzureUnassignedNetworkInterfacesRequest, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'accountId' is not null or undefined
    if (accountId === null || accountId === undefined) {
      throw new RequiredError("ListAzureUnassignedNetworkInterfacesApi", "listAzureUnassignedNetworkInterfaces", "accountId");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("ListAzureUnassignedNetworkInterfacesApi", "listAzureUnassignedNetworkInterfaces", "projectId");
    }


    // verify required parameter 'listAzureUnassignedNetworkInterfacesRequest' is not null or undefined
    if (listAzureUnassignedNetworkInterfacesRequest === null || listAzureUnassignedNetworkInterfacesRequest === undefined) {
      throw new RequiredError("ListAzureUnassignedNetworkInterfacesApi", "listAzureUnassignedNetworkInterfaces", "listAzureUnassignedNetworkInterfacesRequest");
    }


    // Path Params
    const localVarPath = '/projects/{projectId}/restore-accounts/{accountId}/azure/network-interfaces'
      .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.POST, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    // Body Params
    const contentType = "application/json"
    requestContext.setHeaderParam("Content-Type", contentType);
    const serializedBody = JSON.stringify(ObjectSerializer.serialize(listAzureUnassignedNetworkInterfacesRequest, "ListAzureUnassignedNetworkInterfacesRequest", ""));
    requestContext.setBody(serializedBody);

    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class ListAzureUnassignedNetworkInterfacesApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to listAzureUnassignedNetworkInterfaces
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async listAzureUnassignedNetworkInterfacesWithHttpInfo(response: ResponseContext): Promise<HttpInfo<ListAzureUnassignedNetworkInterfaces200Response >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: ListAzureUnassignedNetworkInterfaces200Response = ObjectSerializer.deserialize(
        await response.body.json(),
        "ListAzureUnassignedNetworkInterfaces200Response", ""
      ) as ListAzureUnassignedNetworkInterfaces200Response;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: ListAzureUnassignedNetworkInterfaces200Response = await response.body.json() as ListAzureUnassignedNetworkInterfaces200Response;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
